import styled from 'styled-components';

export const UnstyledLink = styled.a`
  transition: none;

  &,
  &:hover,
  &:active {
    color: inherit;
  }

  &,
  &:focus {
    text-decoration: none;
  }
`;
